import Form from '@platform/form';

const suffix = 'expanded-form-';

export default function useCardTable(Table) {
    return Table;
}

useCardTable.displayName = 'useCardTable';
useCardTable.dependence = [];
useCardTable.hooks = function() {
    this.store.expandedFormStore = {};
    this.store.sideFormStore = null;
    this.store.cardTableModalInfo = {};
    this.store.cardTableConfig = {};
    this.store.relation = null;
    this.store.tabVisible = true;
    this.store.grandData = {};

    this._formatOutputRow = row => {
        if (!row) return;
        return { 
            rowid: row.key, 
            status: row.status, 
            expandRowStatus: this.getExpandedRowKeys().has(row.key),
            selected: this.getCheckedKeys().has(row.key),
            values: row.values,
        };
    };

    let superSetCellValue = this.setCellValue,
        superSetRowData = this.setRowData,
        superSetStatus = this.setStatus;

    this.setCellValue = (rowKey, ...rest) => {
        let res = superSetCellValue.call(this, rowKey, ...rest);

        this.updateComponent(`${suffix}${rowKey}`);
        
        return res;
    };

    this.setRowData = (rowData, config = {}) => {
        let { rowKey } = config;
        let key = rowData.key || rowData.rowId || rowData.rowid || (rowKey && rowData.values[rowKey]);

        let res = superSetRowData.call(this, rowData, config);
        this.updateComponent(`${suffix}${key}`);
        
        return res;
    };

    this.setStatus = status => {
        let res = superSetStatus.call(this, status);

        if (status !== 'browse') {
            this.setExpandAllStatus(false);
        }

        return res;
    },

    // 关闭或者切换Modal的时候，将store中的值同步一下
    this._syncGrandDataFromStore = () => {
        let {
            tableId, 
            rowKey,
            pageScope,
        } = this.store.cardTableModalInfo;

        if (tableId && rowKey && pageScope) {
            let tableStore = pageScope.cardTableDataSource[tableId];
            let grand = tableStore.getRelation()?.grand?.[tableId] || [];
            grand.forEach(grandId => {
                tableStore.setGrandRows(rowKey, grandId, { rows: pageScope.cardTableDataSource[grandId].getRows() }, false);
            });
        }
    };

    return {
        setActiveTab: activeTab => {
            this.store.cardTableActiveTab = activeTab;
            this.forceUpdate();
        },
        getActiveTab: () => {
            return this.store.cardTableActiveTab;
        },
        setTableExpand: isExpand => {
            this.store.cardTableTableExpand = isExpand;
            this.forceUpdate();
        },
        getTableExpand: () => {
            if (this.store.hasOwnProperty('cardTableTableExpand')) {
                return this.store.cardTableTableExpand !== false;
            }
            let meta = this.store.meta;
            return meta?.[meta.mainId].isunfold !== false;
        },
        initExpandedFormStore: (moduleId, rowKey) => {
            if (!this.store.expandedFormStore?.[rowKey]) {
                let formStore = Form.useForm();

                let meta = this.getMeta();
                meta = {
                    ...meta,
                    [moduleId]: {
                        ...meta[moduleId],
                        moduletype: 'form',
                    },
                };

                formStore.setMeta(meta, moduleId);
                formStore.setAllFormValue(this.getRowData(rowKey)?.values || {});

                this.store.expandedFormStore[rowKey] = formStore;
            }
        },
        getExpandedFormStore: rowKey => {
            return this.store.expandedFormStore?.[rowKey];
        },

        openCardTableModal: (tableId, formId, dataIndex, pageScope) => {
            this._syncGrandDataFromStore();

            let tableStore = pageScope.cardTableDataSource[tableId],
                rowKey = tableStore.getRows()[dataIndex].key;

            this.store.cardTableModalInfo = {
                ...this.store.cardTableModalInfo,
                dataIndex,
                open: true,
                tableId,
                formId,
                pageScope,
                rowKey,
            };

            // 更新表单数据
            let row = tableStore.getRowData(rowKey)?.values || {};
            pageScope.formDataSource[formId].setAllFormValue(row);

            // 更新孙表数据
            let grand = tableStore.getRelation()?.grand?.[tableId] || [];
            grand.forEach(grandId => {
                let rows = tableStore.getGrandRows(false)?.[rowKey]?.[grandId] || { rows: [] };
                pageScope.cardTableDataSource[grandId].setRows(rows);
            });

            // 同步表单meta
            let status = tableStore.getStatus(),
                currentRow = tableStore.getRowData(rowKey),
                meta = tableStore.getMeta(),
                destEditAreaCode = meta?.gridrelation?.[formId]?.destEditAreaCode ?? [formId],
                formMeta = { formrelation: {} };

            if (Array.isArray(destEditAreaCode)) {
                formMeta.formrelation[formId] = [];
                destEditAreaCode.forEach((moduleId, index) => {
                    formMeta[moduleId] = {
                        ...meta[moduleId],
                        items: [],
                    };
                    if (index !== 0) {
                        formMeta.formrelation[formId].push(moduleId);
                    }

                    formMeta[moduleId].items = meta[moduleId].items.map(item => {
                        // 同步自定义渲染
                        // 这里基本是抄的以前的
                        if (typeof item.render === 'function') {
                            let { render: oldRender, renderStatus } = item;
                            if (!renderStatus) { 
                                renderStatus = 'edit'; 
                            }
                            let isEditRender = renderStatus === 'edit' && status !== 'browse';
                            let isBrowseRender = renderStatus === 'browse' && status === 'browse';
                            // 判断显示render状态
                            if (isEditRender || isBrowseRender) {
                                item = {
                                    ...item,
                                    renderStatus,
                                    render: () => {
                                        let { dataIndex, pageScope, tableId } = this.store.cardTableModalInfo,
                                            tableStore = pageScope.cardTableDataSource[tableId],
                                            row = tableStore.getRows()[dataIndex];

                                        return oldRender(
                                            row.values[item.attrcode],
                                            row,
                                            dataIndex,
                                        );
                                    },
                                };
                            } 
                        }
        
                        // 同步单元格disabled 三个地方的 1表单模板的  2表格模板的   3cellProps的
                        let cellProps = tableStore.getCellProps(rowKey, item.attrcode),
                            { disabled, required } = { ...item, ...cellProps };
                        pageScope.formDataSource[formId].setItemAttribute?.(item.attrcode, 'disabled', disabled, false);
                        pageScope.formDataSource[formId].setItemAttribute?.(item.attrcode, 'required', required, false);
        
                        return {
                            ...item,
                            disabled,
                            required,
                        };
                    });
                });
            }

            // pageScope.formDataSource[formId].forceUpdate();
            pageScope.formDataSource[formId].setMeta(formMeta, formId);
            this.updateComponent('CardTableWithModal');
        },
        closeCardTableModal: () => {
            this._syncGrandDataFromStore();

            this.store.cardTableModalInfo = {
                ...this.store.cardTableModalInfo,
                rowKey: '',
                open: false,
                tableId: '',
                formId: '',
                pageScope: null,
                // TODO 没有重置dataIndex
            };

            this.updateComponent('CardTableWithModal');
        },
        getCardTableModalInfo: () => {
            return this.store.cardTableModalInfo || {};
        },
        setExpandAllStatus: status => {
            this.store.cardTableExpandAllStatus = status;
            this.forceUpdate();
        },
        getExpandAllStatus: () => {
            return this.store.cardTableExpandAllStatus;
        },
        setMaxStatus: status => {
            this.store.cardTableMaxStatus = status;
            this.forceUpdate();
        },
        getMaxStatus: () => {
            return this.store.cardTableMaxStatus;
        },
        setAreaVisible: visible => {
            this.store.tabVisible = visible;
            this.forceUpdate();
        },
        getAreaVisible: () => {
            return this.store.tabVisible;
        },
        setRelation: relation => {
            this.store.relation = relation;
        },
        getRelation: () => {
            return this.store.relation;
        },
        // 从store同步值过来时不用再同步回store
        setGrandRows: (rowKey, grandId, data, sync = true) => {
            if (!this.store.grandData[rowKey]) {
                this.store.grandData[rowKey] = {};
            }
            this.store.grandData[rowKey][grandId] = data;

            let {
                tableId, 
                rowKey: currentRowKey,
                pageScope,
            } = this.store.cardTableModalInfo;
            
            // 同步当前侧拉中的值
            if (sync && tableId && rowKey && pageScope && currentRowKey === rowKey) {
                pageScope.cardTableDataSource[grandId].setRows(data);
            }
        },
        // 内部setGrandRows之前会get，这时候不同步
        getGrandRows: (sync = true) => {
            sync && this._syncGrandDataFromStore();

            return this.store.grandData;
        },
        deleteGrandRows: rowKey => {
            delete this.store.grandData[rowKey];
        },
        clearGrandRows: () => {
            this.store.grandData = {};
        },
    };
};
useCardTable.propsGenerator = function(props) {
    return {
        ...props,
        cardTableModalConfig: {
            ...props.cardTableModalConfig,
            ...props.store.getCardTableModalInfo(),
            onClose: () => {
                props.store.closeCardTableModal();
            },
        },
    };
};